/* eslint-disable jsx-a11y/label-has-associated-control */
import { forwardRef } from "react"

type LabelOwnProps = Readonly<{
  valueFor: string
}>

export type LabelProps = LabelOwnProps & Omit<React.ComponentPropsWithRef<"label">, "htmlFor">

const Label: React.FC<LabelProps> = forwardRef(({ valueFor, ...labelProps }: LabelProps, forwardedRef) => (
  <label ref={forwardedRef} htmlFor={valueFor} {...labelProps} />
))

Label.displayName = `RadioGroupLabel`

export { Label }
